const invertedMessages = {
  'Row actions': 'external.userManagement.actionMenu.rowActions',
  Update: 'external.userManagement.actionMenu.update',
  Search: 'external.userManagement.actionMenu.search',
};

export default invertedMessages;
